<app-page-header [title]="title"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <div class="row">
    <div class="col-lg-12 text-center h3 mt-4">
      Nincs releváns adat.
    </div>
  </div>
</div>
